import { Injectable } from '@angular/core';

import { TranslateService } from '@jht/brand-translate';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ContentService } from './../../../../shared/content/content.service';
import { Country, CountrySelectOption } from './model';

@Injectable({
    providedIn: 'root',
})
export class CountrySelectorService {
    private countries = new BehaviorSubject<any>(null);

    constructor(
        private contentService: ContentService,
        private translate: TranslateService,
    ) {
        this.setCountries();
    }

    setCountries(): void {
        this.contentService
            .getComponent('contact-us-country-selector')
            .pipe(
                filter((countries) => !!countries),
                map((countries) => countries),
            )
            .subscribe((countries: Country[]) => {
                this.mapCountryOptions(countries);
            });
    }

    mapCountryOptions(countries: Country[]): void {
        const options = countries.map((country: Country) => {
            const recipientCode = country['country-recipient-code']
                ? country['country-recipient-code']
                : 'WORLD';
            const recipientKey = this.translate.instant(
                `GLOBAL_FORMS_COUNTRIES_RECIPIENT_${recipientCode}`,
            );
            return {
                recipientCode: recipientCode,
                recipient: recipientKey,
                value: country['country-name'],
            };
        });

        options.sort(function (a, b) {
            if (a.value < b.value) {
                return -1;
            }
            if (a.value > b.value) {
                return 1;
            }
            return 0;
        });

        this.countries.next(options);
    }

    getCountries(): BehaviorSubject<CountrySelectOption[]> {
        return this.countries;
    }
}
